import { useTranslation } from 'react-i18next';

import './BrandShowcase.less';

export const BrandShowcase = () => {
  const { i18n, t } = useTranslation();
  const isZh = i18n.resolvedLanguage === 'zh';
  return (
    <div className="brand-show-case-container relative flex h-full flex-auto flex-col items-center justify-center bg-[white] pb-[50px]">
      <div className="flex w-full justify-center px-8">
        <div className="max-w-[736px]">
          <div className=" mb-8  text-[48px] font-extrabold leading-[58px] text-[#111314]">
            {isZh ? (
              <>
                灵感一闪
                <br />
                代码<span className="text-[#29E2CC] ">即现</span>
              </>
            ) : (
              <>
                Code Begins
                <br />
                with a <span className="text-[#29E2CC] ">Flicker.</span>
              </>
            )}
          </div>
          <img
            src={
              isZh
                ? 'https://h23.static.yximgs.com/kos/nlav12119/dMyZdSPp_2026-02-04-16-50-58.png'
                : 'https://h23.static.yximgs.com/kos/nlav12119/TKVQrQeV_2026-02-04-16-56-29.jpg'
            }
            className="brand-show-case relative w-full rounded from-[#ffffff66] to-[#ffffff29] bg-contain bg-center bg-no-repeat"
          />
        </div>
      </div>
      <div
        className=" absolute bottom-0 left-0 flex h-[152px]  w-full items-center justify-center gap-2 rounded-t-[16px] bg-[rgba(255,255,255,0.5)] px-8 py-4 text-[#111314]  "
        style={{
          backdropFilter: 'blur(50px)',
          boxShadow: '0px -4px 20px 0px #A4D2E059',
        }}
      >
        <div className="w-[736px]">
          <div className=" flex  flex-col xl:flex-row  xl:items-center xl:justify-normal xl:gap-[53px]">
            <div className="w-fit  whitespace-nowrap text-[24px] font-extrabold leading-[28px]">
              {t('brandShowcase.title')}
            </div>
            <div>{t('brandShowcase.description')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
